import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import me from "../../assets/home/me.png";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".header");
      if (window.scrollY >= 80) {
        header.classList.add("scroll-header");
      } else {
        header.classList.remove("scroll-header");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (location.hash && isHomePage) {
      setTimeout(() => {
        const section = document.querySelector(location.hash);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location.hash, isHomePage]);

  const [menu, setMenu] = useState(false);

  // Close menu when clicking outside
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        menu &&
        !e.target.closest("#nav-menu") &&
        !e.target.closest("#nav-toggle")
      ) {
        setMenu(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [menu]);

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();

    if (isHomePage) {
      const section = document.querySelector(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(`/${sectionId}`);
      // If navigating to home with a hash, the previous generic effect will handle it
    }
    setMenu(false);
  };

  return (
    <header className="header" id="header">
      <nav className="nav container">
        <div className="nav__left">
          <Link
            to="/"
            className="nav__link nav__brand"
            onClick={(e) => handleNavClick(e, "#home")}
          >
            Ahad Ali
          </Link>
        </div>

        <div className="nav__center">
          <div
            className={menu ? "nav__menu show-menu" : "nav__menu"}
            id="nav-menu"
          >
            <ul className="nav__list">
              <li className="nav__item">
                <Link
                  to="/"
                  className="nav__link"
                  onClick={(e) => handleNavClick(e, "#process")}
                >
                  Process{" "}
                  <i className="uil uil-arrow-up-right nav__link-icon" />
                </Link>
              </li>
              <li className="nav__item">
                <Link
                  to="/"
                  className="nav__link"
                  onClick={(e) => handleNavClick(e, "#featured__projects")}
                >
                  Works <i className="uil uil-arrow-up-right nav__link-icon" />
                </Link>
              </li>
              <li className="nav__item">
                <Link
                  to="/"
                  className="nav__link"
                  onClick={(e) => handleNavClick(e, "#about")}
                >
                  About <i className="uil uil-arrow-up-right nav__link-icon" />
                </Link>
              </li>
              <li className="nav__item">
                <Link
                  to="/"
                  className="nav__link"
                  onClick={(e) => handleNavClick(e, "#testimonials")}
                >
                  Testimonials{" "}
                  <i className="uil uil-arrow-up-right nav__link-icon" />
                </Link>
              </li>
            </ul>

            {/* Mobile Footer CTA */}
            <div className="nav__menu-footer">
              <a
                href="https://wa.me/923241441444"
                target="_blank"
                rel="noreferrer"
                className="nav__cta nav__cta--mobile"
              >
                <div className="nav__cta-avatar">
                  <img src={me} alt="Ahad Ali" />
                  <div className="nav__cta-status">
                    <i className="uil uil-whatsapp"></i>
                  </div>
                </div>
                <span className="nav__cta-text">Chat with Ahad</span>
              </a>
            </div>

            <i
              className="uil uil-times nav__close"
              id="nav-close"
              onClick={() => setMenu(false)}
            ></i>
          </div>
        </div>

        <div className="nav__right">
          <div className="nav__btns">
            <a
              href="https://wa.me/923241441444"
              target="_blank"
              rel="noreferrer"
              className="nav__cta nav__cta--desktop"
            >
              <div className="nav__cta-avatar">
                <img src={me} alt="Ahad Ali" />
                <div className="nav__cta-status">
                  <i className="uil uil-whatsapp"></i>
                </div>
              </div>
              <span className="nav__cta-text">Chat with Ahad</span>
            </a>

            <div
              className="nav__toggle"
              id="nav-toggle"
              onClick={() => setMenu(true)}
            >
              <i className="uil uil-bars"></i>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
